import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { uiActions } from '../../store/ui-slice';

import Button from '../commons/Button';

const GenericError = () => {
  const dispatch = useDispatch();
  const { title, body } = useSelector((state) => state.ui.errorStatus);

  const renderBodyJSX = () => {
    if (body.indexOf('%%' !== -1)) {
      return body.split('%%').map((msg) => <p className="body" key={msg}>{msg}</p>);
    }
    if (body) {
      return <p className="body">body</p>;
    }
    return <p className="body">Intenta actualizar la página o intentar nuevamente más adelante.</p>;
  };

  return (
    <div className="generic-error">
      <h2 className="title">{title || 'Ocurrió un error'}</h2>
      {renderBodyJSX()}
      <Button
        label="Cerrar"
        onClick={() => dispatch(uiActions.clearErrorStatus())}
        buttonClasses="align-center"
        iconClasses="times"
        iconPosition="after" />
    </div>
  );
};

export default GenericError;
